module.exports = __webpack_public_path__ + "video-play-dc34cc9c99e935cd9c88c036e34103f5.png";


//////////////////
// WEBPACK FOOTER
// ./~/lightgallery/dist/img/video-play.png
// module id = 918
// module chunks = 124